import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { AlertTriangle } from 'lucide-react';
import { useEntitlements } from '@/hooks/useEntitlements';

/**
 * Shown app-wide when the workspace has a pending GDPR account deletion.
 */
export function DeletionPendingBanner() {
  const { t } = useTranslation('settings');
  const { pendingDeletion, loading } = useEntitlements();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(!loading && pendingDeletion != null);
  }, [pendingDeletion, loading]);

  if (!visible || !pendingDeletion) return null;

  const scheduledLabel = new Date(pendingDeletion.scheduledAt).toLocaleDateString(undefined, {
    dateStyle: 'long',
  });

  return (
    <div
      role="status"
      className="flex shrink-0 flex-wrap items-center justify-center gap-x-2 gap-y-1 border-b border-red-500/40 bg-red-950/90 px-4 py-2.5 text-center text-xs font-semibold text-red-50 sm:text-sm"
    >
      <AlertTriangle className="hidden h-4 w-4 shrink-0 sm:inline" aria-hidden />
      <span>{t('deletion.banner.message', { date: scheduledLabel })}</span>
      <Link to="/settings/profile" className="underline underline-offset-2 hover:opacity-90">
        {t('deletion.banner.cta')}
      </Link>
    </div>
  );
}
